import { Header, Page } from 'redesign';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { SettingEditThemeForm } from './setting-edit-theme-form';
import { SettingsEditThemeToolbox } from './setting-edit-theme-toolbox';
import { useSettingsEditThemeForm } from '../hooks/use-settings-edit-theme-form';
import { useSettingsEditThemeSync } from '../hooks/use-settings-edit-theme-sync';
import { useSettingsEditThemeHandlers } from '../hooks/use-settings-edit-theme-handlers';

export const SettingsEditThemePageDataProvider = () => {
  return <SettingsEditTheme />;
};

export const SettingsEditTheme = () => {
  const { t } = useTranslation('ogp-screen-specific');

  const { formMethods, originalThemeRef } = useSettingsEditThemeForm();

  useSettingsEditThemeSync({
    formMethods,
    originalThemeRef,
  });

  const { handleSubmit, handleCancel } = useSettingsEditThemeHandlers({
    formMethods,
    originalThemeRef,
  });

  return (
    <form>
      <FormProvider {...formMethods}>
        <Page
          toolbox={
            <SettingsEditThemeToolbox handleSubmit={handleSubmit} handleCancel={handleCancel} />
          }
          header={<Header titleText={t('settings-edit-theme-page.title')} />}
        >
          <SettingEditThemeForm />
        </Page>
      </FormProvider>
    </form>
  );
};
